import styled from 'styled-components';

export const Wrapper = styled.div<{ showtitlestyles: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 40px;

  ${({ showtitlestyles, theme }) =>
    showtitlestyles &&
    `& > :first-child {
    display: flex;
    align-items: center;
    gap: 10px;
    font-family: ${theme.fontFamily.primary};
    font-feature-settings: 'liga' off, 'clig' off;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 32px;
    letter-spacing: -0.2px
    i {
      font-size: 24px;
    }
  }`}

  @media (min-width: ${({ theme }) => theme.mediaQueries.xs}) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    & > :nth-child(2):has(button, div),
    & > :nth-child(2):has(div, button),
    & > :nth-child(2):has(button, button),
    & > :nth-child(2):has(div, div),
    & > :nth-child(2):has(div, div, div) {
      display: flex;
      gap: 20px;
      align-items: center;
    }
  }
`;
